import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { authenticationGuard } from './core/guards/authentication.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'qlcv',
    pathMatch: 'full'
  },
  {
    path: 'qlcv',
    loadChildren: () =>
      import('./features/authentication/authentication.module').then(
        (module) => module.AuthenticationPageModule,
      ),
  },
  {
    path: 'workspace',
    canActivate: [authenticationGuard],
    loadChildren: () =>
      import('./features/workspace/workspace.module').then(
        (module) => module.WorkspacePageModule,
      ),
  },
  {
    path: 'dashboard',
    canActivate: [authenticationGuard],
    loadChildren: () =>
      import('./features/dashboard/dashboard.module').then(
        (module) => module.DashboardPageModule,
      ),
  },
  {
    path: 'tasks',
    canActivate: [authenticationGuard],
    loadChildren: () =>
      import('./features/tasks/pages/task-management/task-management.module').then(
        (module) => module.TaskManagementPageModule,
      ),
  },
  {
    path: 'employees/import',
    canActivate: [authenticationGuard],
    loadChildren: () =>
      import('./features/employees/pages/employee-import/employee-import.module').then(
        (module) => module.EmployeeImportPageModule,
      ),
  },
  {
    path: '**',
    redirectTo: 'qlcv',
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
